import './Factset.scss';

import React from 'react';

import Content from 'services/Content';
import IframeHelper from 'components/shared/Iframe/IframeHelper';
import { factset } from 'services/Externals';

class Factset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewDisclosure: false
    };
  }

  viewDisclosureClickHandler = () => {
    this.setState((prevState) => ({
      viewDisclosure: !prevState.viewDisclosure
    }));
  };

  render() {
    const {
      frameWidth = '100%',
      frameHeight = '100%',
      allowScrolling = 'no',
      borderWidth = '0',
      marginWidth = '0',
      marginHeight = '0',
      includeDisclosure
    } = this.props;

    const { viewDisclosure } = this.state;
    const viewLabel = viewDisclosure ? 'Hide Disclosure' : '*View Disclosure';

    return (
      <div className="factset">
        {includeDisclosure && (
          <div className="factsetDisclosure">
            <a className="viewLabel" onClick={this.viewDisclosureClickHandler}>
              {viewLabel}
            </a>

            {viewDisclosure && (
              <div
                className="disclosure-text"
                dangerouslySetInnerHTML={{ __html: Content.factsetDisclosure }}
              />
            )}
          </div>
        )}
        <IframeHelper
          source={factset.factsetUrl}
          frameWidth={frameWidth}
          frameHeight={frameHeight}
          allowScrolling={allowScrolling}
          borderWidth={borderWidth}
          marginWidth={marginWidth}
          marginHeight={marginHeight}
        />
      </div>
    );
  }
}

Factset.defaultProps = {
  frameWidth: '100%',
  frameHeight: '100%',
  allowScrolling: 'no',
  borderWidth: '0',
  marginWidth: '0',
  marginHeight: '0'
};

export default Factset;
